<button (click)="onENDChartClick()" class="graph mat-elevation-z2">
  <div id="end-chart" class="plotly-graph" [class]="getGraphClass()"></div>
  @if (!getShowGraphs()) {
    <div>Create dive segements to populate graphs</div>
  }
</button>
